import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PrimaryRelatedContentComponent } from './primary-related-content.component'
import { RouterModule } from '@angular/router'
import { ContentSmallModule } from '../content-small/content-small.module'
import { AnalyticsModule } from '../../shared/analytics/analytics.module'
import { FloPipeModule } from '../../shared/pipes/flo-pipe.module'

@NgModule({
  declarations: [PrimaryRelatedContentComponent],
  exports: [PrimaryRelatedContentComponent],
  imports: [CommonModule, RouterModule, ContentSmallModule, AnalyticsModule, FloPipeModule]
})
export class PrimaryRelatedContentModule {}
